import React from "react";
import { connect } from "react-redux";
import { Grid } from "react-md";
import { MSpinner } from "components/Shared";
import CustomerDetails from "components/Customer/Profile/CustomerDetails";
import CustomerDetailsQadDisplay from "components/QualityAssurance/CustomerQAEmployeesDisplay.tsx";
import FeaturePermissionStates from "components/Shared/FeaturePermissionStates.tsx";
import { CustomerDetailsDto } from "interfaces/Mueller.Business.Models.ts";
import FeaturePermissionTypeCodes from "typeConstants/featurePermissionCodes.ts";
import CustomerEmailCaseSettings from "components/Customer/Profile/CustomerEmailCaseSettings.tsx";
import CustomerNavigationCard from "components/Customer/Profile/CustomerNavigationCard.tsx";
import CustomerSalesDetails from "./CustomerSalesDetails.tsx";
import CustomerCalcSettingsGrid from "../CalcSettings/CustomerCalcSettingsGrid.tsx";
import CustomerExperienceAssignment from "../CustomerExperienceAssignment.tsx";
import PDFExportSettings from "./PDFExportSettings.tsx";

interface CustomerProfileProps {
  verticalDisplay: boolean;
  // redux
  customerDetails: CustomerDetailsDto;
  fetchingCustomerDetails: boolean;
}

const CustomerProfile = ({
  customerDetails,
  fetchingCustomerDetails,
  verticalDisplay,
}: CustomerProfileProps) => {
  const cellWidth = verticalDisplay ? 12 : 4;

  if (fetchingCustomerDetails) return (<MSpinner />);

  return (
    <Grid>
      <CustomerDetails cellWidth={cellWidth} />
      <CustomerSalesDetails customerNumber={customerDetails?.number} cellWidth={cellWidth} />
      <CustomerDetailsQadDisplay cellWidth={cellWidth} />
      <CustomerExperienceAssignment verticalDisplay={verticalDisplay} customerNumber={customerDetails?.number} />
      <CustomerEmailCaseSettings />
      <FeaturePermissionStates
        cellWidth={cellWidth}
        customerNumber={customerDetails?.number}
        featurePermissionType={FeaturePermissionTypeCodes.CALL_CENTER_INCLUSION}
      />
      <CustomerNavigationCard 
        customerNumber={customerDetails?.number}
        verticalDisplay={verticalDisplay}
      />
      <CustomerCalcSettingsGrid customerNumber={customerDetails?.number} />
      <PDFExportSettings customerNumber={customerDetails?.number} cellWidth={cellWidth} />
    </Grid>
  );
};

const mapStateToProps = state => ({
  customerDetails: state.customer.customerDetails,
  fetchingCustomerDetails: state.customer.fetchingCustomerDetails,
});

export default connect(mapStateToProps)(CustomerProfile);
